import { RootState } from 'redux/type';

// MODEL
import {
  OnBoardingState,
  AccountStatus,
  LovedOneType,
  B3LookupResult,
  BlockedReason,
  B3ClientSnapshot,
  LinkpassPrefill
} from 'model';

// ----------------------------- ONBOARDING STATE -----------------------------------

export const selectOnBoardingState = (state: RootState): OnBoardingState => state.onBoardingReducer;

// ----------------------------- LOADING -----------------------------------

export const selectOnBoardingLoading = (state: RootState): boolean => state.onBoardingReducer.loading;

// ----------------------------- CHECKING ACCOUNT STATUS -----------------------------------

export const selectIsCheckingAccountStatus = (state: RootState): boolean =>
  state.onBoardingReducer.isCheckingAccountStatus;

// ----------------------------- LOVED ONE -----------------------------------

export const selectOnBoardingLovedOne = (state: RootState): LovedOneType | '' => state.onBoardingReducer.lovedOne;

// ----------------------------- NRIC -----------------------------------

export const selectOnBoardingNric = (state: RootState): string => state.onBoardingReducer.nric;

// ----------------------------- ACCOUNT STATUS -----------------------------------

export const selectAccountStatus = (state: RootState): AccountStatus | undefined =>
  state.onBoardingReducer.accountStatus;

// ----------------------------- SUGGESTED ROLE -----------------------------------

export const selectSuggestedRole = (state: RootState): 'SELF' | null | undefined =>
  state.onBoardingReducer.suggestedRole;

// ----------------------------- VERIFIED -----------------------------------

export const selectIsVerified = (state: RootState): boolean => state.onBoardingReducer.isVerified;

// ----------------------------- SESSION ID -----------------------------------

export const selectSessionId = (state: RootState): string | undefined => state.onBoardingReducer.sessionId;

// ----------------------------- B3 LOOKUP RESULT -----------------------------------

export const selectB3LookupResult = (state: RootState): B3LookupResult | undefined =>
  state.onBoardingReducer.b3LookupResult;

// ----------------------------- MOBILE LAST 4 -----------------------------------

export const selectMobileLast4 = (state: RootState): string | null | undefined =>
  state.onBoardingReducer.mobileLast4;

// ----------------------------- LOOKUP BLOCKED REASON -----------------------------------

export const selectLookupBlocked = (state: RootState): BlockedReason | null | undefined =>
  state.onBoardingReducer.lookupBlocked;

// ----------------------------- COMPLETED ONBOARD -----------------------------------

export const selectCompletedOnboard = (state: RootState): boolean | undefined =>
  state.onBoardingReducer.completedOnboard;

// ----------------------------- B3 CLIENT SNAPSHOT -----------------------------------

export const selectB3Snapshot = (state: RootState): B3ClientSnapshot | undefined =>
  state.onBoardingReducer.b3Snapshot;

// ----------------------------- B3 HAS ACTIVE PACKAGE -----------------------------------

export const selectB3HasActivePackage = (state: RootState): boolean | undefined =>
  state.onBoardingReducer.b3HasActivePackage;

// ----------------------------- LINKPASS PREFILL -----------------------------------

export const selectLinkpassPrefill = (state: RootState): LinkpassPrefill | undefined =>
  state.onBoardingReducer.linkpassPrefill;

// ----------------------------- LOCAL SESSION ID -----------------------------------

export const selectLocalSessionId = (state: RootState): string | undefined =>
  state.onBoardingReducer.localSessionId;
